<template>
  <div class="blok-button" v-editable="blok" :style="wrapStyles">
    <a
      @click="downloadButtonClick"
      :aria-label="buttonTitle"
      :class="linkClasses"
      download
    >
      {{ buttonTitle }}
    </a>
  </div>
</template>

<script>
export default {
  props: ['blok'],
  data() {
    return {
      isDownloadAttempt: false,
    }
  },
  computed: {
    wrapStyles() {
      return { 'text-align': this.blok.align }
    },
    linkClasses() {
      let appliedClasses = ''
      const styleClasses = {
        'main-button': 'cta-button',
        'medium-button': 'cta-button medium-button-dark',
        'low-button': 'cta-button low-button',
      }
      const sizeClasses = {
        small: 'cta-button-small',
        normal: '',
        wide: 'cta-button-wide',
      }
      const styleClassToApply = styleClasses[this.blok.style]
      if (styleClassToApply) {
        appliedClasses += styleClassToApply
      }
      const sizeClassToApply = sizeClasses[this.blok.size]
      if (sizeClassToApply) {
        appliedClasses = appliedClasses + ' ' + sizeClassToApply
      }
      return appliedClasses
    },
    userId() {
      return this.$store.state.user.currentUser.userId || 'guest'
    },
    level() {
      return this.blok ? this.blok.level : 'free'
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    buttonTitle() {
      return this.isLoggedIn
        ? this.blok.text
        : this.blok.level_title || this.blok.text
    },
  },
  methods: {
    downloadButtonClick() {
      if (this.level === 'registered' && !this.isLoggedIn) {
        this.isDownloadAttempt = true
        this.$store.dispatch('showModal', 'register')
        const actionTitle = this.blok.analytics_id
          ? `click-register-${this.blok.analytics_id}`
          : 'click-storyblok-register'
        this.$ga.event({
          eventCategory: 'Click',
          eventAction: actionTitle,
          eventLabel: 'UserID ' + this.userId,
        })
        this.$gtag.event(actionTitle, {
          'event_category': 'Click',
          'event_label': 'UserID ' + this.userId,
        })
        return
      }
      this.openFile()
    },
    openFile() {
      const actionTitle = this.blok.analytics_id
        ? `click-${this.blok.analytics_id}`
        : 'click-storyblok-download'
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: actionTitle,
        eventLabel: 'UserID ' + this.userId,
      })
      this.$gtag.event(actionTitle, {
        'event_category': 'Click',
        'event_label': 'UserID ' + this.userId,
      })
      window.open(this.blok.link, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.blok-button a {
  margin: 10px;
  display: inline-block;
  white-space: nowrap;
  &:hover {
    text-decoration: none;
  }
}
.main-button {
  color: $btn-std-color;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  background: $btn-std-bg;
  padding: $btn-big-padding;
  border: 0px;
  border-radius: $btn-big-radius;
  font-size: $btn-big-text;
  font-weight: 400;
  min-width: $btn-big-width;
  &:hover {
    background: $btn-std-hover;
  }
}
.flat-button {
  background-color: transparent;
  color: #2196f3;
  transition: background-color 0.2s;
  border: none;
  border-radius: 2px;
  text-transform: uppercase;
  &:hover {
    text-decoration: none;
    background: #eef3f6;
  }
}
</style>
